// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_wb-8";
export var editMode = "_wb-3";
export var headerRow = "_wb-a";
export var headerTitle = "_wb-b";
export var product = "_wb-1";
export var productDetails = "_wb-5";
export var productDivider = "_wb-7";
export var productImage = "_wb-2";
export var productInfo = "_wb-4";
export var productTitle = "_wb-6";
export var strikethrough = "_wb-9";
export var upsellProductsCard = "_wb-0";